

import React, { useRef, useEffect } from 'react';
import { Container  } from 'reactstrap';
import './header.css';

const navItems = [
    {
        title: 'Home',
        url: '#home',
    },
    {
        title: 'About',
        url: '#about'
    },
    {
        title: 'Services',
        url: '#services'
    },
    {
        title: 'Projects',
        url: '#projects'
    },
    {
        title: 'Contact',
        url: '#contact'
    }  
    
]

const Header = () => {
    
    const headerRef = useRef(null);

    const menuRef = useRef(null);

    useEffect(() => {
      window.addEventListener('scroll', ()=>{
        if(document.body.scrollTop > 80 || document.documentElement.scrollTop > 80){
            headerRef.current.classList.add('header__shrink')
        } else{
            headerRef.current.classList.remove('header__shrink')
        }
      })
      return ()=> {
        window.removeEventListener('scroll')
      }
    }, []);

    const menuToggle = ()=> menuRef.current.classList.toggle('menu__active')

    const handleClick = e=>{
        e.preventDefault();
        const targetAttr = e.target.getAttribute('href');
        const location = document.querySelector(targetAttr).offsetTop;

        window.scrollTo({
            left: 0,
            top: location - 70
        });
    };
    

  return (
    <header className='header' ref={headerRef}>
        <Container>
        <div className='navbar d-flex align-items-center justify-content-between'>
            <div className="logo">
                <h3><a href="/">SawaJr.</a></h3>
            </div>
            <div className="navbar_list" ref={menuRef} onClick={menuToggle}>
                <ul className="nav-list">
                    {
                        navItems.map((item, index) => 
                            <li className="nav-items" key={index}>
                                <a href={item.url} onClick={handleClick}>{item.title}</a>
                            </li>

                        )
                    }
                </ul>
            </div>

            <div className="nav-button d-flex align-items-center gap-4">
                <button className='btn'><a href="https://www.github.com/sawalandry" target='_blank' rel="noreferrer">My Github <i className="ri-github-line"></i></a></button>
                <span className="mobile-nav">
                <i className="ri-menu-5-line" onClick={menuToggle}></i>
                </span>
            </div>
        </div>
    </Container>
    </header>
    
  )
}

export default Header